import * as React from 'react';
import styled from 'styled-components';

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const LoadingContent = styled.div`
  text-align: center;
  max-width: 400px;
  padding: 20px;
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingTitle = styled.h3`
  color: #333;
  margin: 0 0 10px 0;
  font-size: 24px;
`;

const LoadingMessage = styled.p`
  color: #666;
  font-size: 16px;
  margin: 0 0 20px 0;
  line-height: 1.5;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 10px;
`;

const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  width: ${props => props.progress}%;
  transition: width 0.5s ease;
`;

const SecurityNote = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #4caf50;
  font-size: 14px;
  margin-top: 15px;

  i {
    font-size: 18px;
  }
`;

interface ImprovedLoadingProps {
  message?: string;
  showProgress?: boolean;
}

export const ImprovedLoading: React.FC<ImprovedLoadingProps> = ({ 
  message = 'Processando seu pagamento...',
  showProgress = true
}) => {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    if (!showProgress) return;

    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) return prev;
        return prev + Math.random() * 15;
      });
    }, 500);

    return () => clearInterval(interval);
  }, [showProgress]);

  return (
    <LoadingOverlay>
      <LoadingContent>
        <Spinner />
        <LoadingTitle>Aguarde um momento</LoadingTitle>
        <LoadingMessage>{message}</LoadingMessage>
        
        {showProgress && (
          <>
            <ProgressBar>
              <ProgressFill progress={progress} />
            </ProgressBar>
            <div style={{ color: '#999', fontSize: '14px' }}>
              {Math.round(progress)}%
            </div>
          </>
        )}
        
        <SecurityNote>
          <i className="material-icons">lock</i>
          <span>Transação segura e criptografada</span>
        </SecurityNote>
      </LoadingContent>
    </LoadingOverlay>
  );
};

